import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import toastr from "toastr";
// Item Redux States
import {
  GET_ITEMS,
  POST_ITEM,
  GET_ITEM_BY_TOKEN,
  POST_ITEM_SALE,
  GET_ACTIVITIES,
  POST_ITEM_BUY,
  GET_ITEM,
  PUT_ITEM,
  POST_TOGGLE_ITEM_SALE,
  POST_BID,
  DELETE_BID,
  POST_BID_ACTION,
  GET_BIDS,
  POST_FAVOURITE,
  GET_FAVOURITE,
  GET_SEARCH,
  REPORT_ABUSE,
  UPCOMING_AUCTION,
  GET_ITEM_BY_ID,
  GET_ITEM_BY_CURRENT_OWNER_ID,
  LIKE_VIEW_COUNT,
  USER_ALL_NFT_COUNT,
  NFT_FROM_COLLECTION,

  /* DELETE_ITEM, */
} from "./actionTypes";
import {
  getItemsFail,
  getItemsSuccess,
  postItemFail,
  postItemSuccess,
  getItemFail,
  getItemSuccess,
  postItemSaleFail,
  postItemSaleSuccess,
  getActivitiesFail,
  getActivitiesSuccess,
  postItemBuyFail,
  postItemBuySuccess,
  putItemFail,
  putItemSuccess,
  postToggleItemSaleFail,
  postToggleItemSaleSuccess,
  postBidFail,
  postBidSuccess,
  deleteBidFail,
  deleteBidSuccess,
  postBidActionFail,
  postBidActionSuccess,
  getBidsFail,
  getBidsSuccess,
  postFavouriteFail,
  postFavouriteSuccess,
  getFavouriteFail,
  getFavouriteSuccess,
  getSearchFail,
  getSearchSuccess,
  reportAbuseFail,
  reportAbuseSuccess,
  upcomingAuctionFail,
  upcomingAuctionSuccess,
  getItemsByIdSuccess,
  getItemsByIdFail,
  getItemsOfCurrentOwnerByIdSuccess,
  getItemsOfCurrentOwnerByIdFail,
  likeViewCountFail,
  likeViewCountdSuccess,
  userAllNftCountSuccess,
  userAllNftCountFail,
  nftFromCollectionSuccess,
  nftFromCollectionFail,
  /* deleteItemFail,
  deleteItemSuccess, */
} from "./actions";

import {
  getItems,
  postItem,
  getItemByToken,
  postItemSale,
  getActivities,
  postItemBuy,
  getItem,
  putItem,
  postToggleItemSale,
  postBid,
  deleteBid,
  postBidAction,
  getBids,
  postFavourite,
  getFavourite,
  getBlogsById,
  getSearchData,
  reportAbuse,
  postUpcomingAuction,
  getItemByIdApi,
  getCurrentOwerItemsApi,
  likeViewCountApi,
  userAllNftCountApi,
  nftFromCollectionApi,
  /* deleteItem, */
} from "helpers/backend_helper";
import { responsiveFontSizes } from "@mui/material";

function* onReportAbuse({ payload: { data, callback } }) {
  try {
    const response = yield call(reportAbuse, data);
    callback && callback(response);
    if (response.status == "failure") {
      return yield put(reportAbuseFail(response.message));
    }
    yield put(reportAbuseSuccess());
  } catch (error) {
    yield put(reportAbuseFail("Internal Error!"));
  }
}

function* onPostItem({ payload: { item, callback } }) {
  try {
    const response = yield call(postItem, item);
    callback && callback(response);

    if (response.status == "failure") {
      // callback && callback(response);
      window.scrollTo(0, 0);
      return yield put(postItemFail(response.message));
    }
    yield put(postItemSuccess());
    // callback && callback(response);
    // callback("/profile");
  } catch (error) {
    yield put(postItemFail("Internal Error!"));
  }
}

function* fetchItems({ payload }) {
  try {
    const response = yield call(getItems, payload);
    if (response.status === "failure") {
      return yield put(getItemsFail(response.message));
    }
    yield put(getItemsSuccess(response));
  } catch (error) {
    yield put(getItemsFail(error));
  }
}

function* onGetItemByToken({ payload: { token, callback } }) {
  try {
    const response = yield call(getItemByToken, token);

    if (response.status === "failure") {
      return yield put(getItemFail(response.message));
    }
    callback && callback();
    yield put(getItemSuccess(response));
  } catch (error) {
    yield put(getItemFail(error));
  }
}

function* onPostItemSale({ payload: { data, callback } }) {
  try {
    const response = yield call(postItemSale, data);
    callback && callback(response);
    if (response.status === "failure") {
      return yield put(postItemSaleFail(response.message));
    }

    yield put(postItemSaleSuccess(response.data));
    callback("/");
  } catch (error) {
    yield put(postItemSaleFail(error));
  }
}

function* fetchItem({ payload }) {
  try {
    const response = yield call(getItem, payload);

    if (response.status === "failure") {
      return yield put(getItemFail(response.message));
    }

    yield put(getItemSuccess(response));
  } catch (error) {
    yield put(getItemFail(error));
  }
}

function* onPutItem({ payload: { data, callback } }) {
  try {
    const response = yield call(putItem, data);

    if (response.status === "failure") {
      return yield put(putItemFail(response.message));
    }



    yield put(putItemSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(putItemFail("Internal Error!"));
  }
}

/* function* onDeleteItem({ payload: { data, callback } }) {
  try {
    const response = yield call(deleteItem, data)

    if (response.status == "failure") {
      return yield put(deleteItemFail(response.message))
    }

    yield put(deleteItemSuccess())
    callback && callback()
  } catch (error) {
    yield put(deleteItemFail("Internal Error!"))
  }
} */

function* onGetActivities({ payload: { data, callback } }) {
  try {
    const response = yield call(getActivities, data);

    if (response.status === "failure") {
      return yield put(getActivitiesFail(response.message));
    }

    yield put(getActivitiesSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(getActivitiesFail("Internal Error!"));
  }
}

function* onPostItemBuy({ payload: { data, callback } }) {
  try {
    const response = yield call(postItemBuy, data);

    if (response.status === "failure") {
      toastr.error(response.message);
      return yield put(postItemBuyFail(response.message));
    }
    yield put(postItemBuySuccess(response.data));

    callback && callback(response);
    toastr.success(response.message);
  } catch (error) {
    yield put(postItemBuyFail("Internal Error!"));
  }
}

function* onPostToggleItemSale({ payload: { data, callback } }) {
  try {
    const response = yield call(postToggleItemSale, data);
    callback && callback(response);
    if (response.status === "failure") {
      return yield put(postToggleItemSaleFail(response.message));
    }
    yield put(postToggleItemSaleSuccess(response.data));
  } catch (error) {
    yield put();
  }
}

function* onPostBid({ payload: { data, callback } }) {
  try {
    const response = yield call(postBid, data);

    if (response.status === "failure") {
      toastr.error(response.message);
      return yield put(postBidFail(response.message));
    }

    yield put(postBidSuccess(response.data));
    callback && callback(response);
  } catch (error) {
    yield put(postBidFail(""));
  }
}

function* onDeleteBid({ payload: { data, callback } }) {
  try {
    const response = yield call(deleteBid, data);

    if (response.status === "failure") {
      return yield put(deleteBidFail(response.message));
    }

    yield put(deleteBidSuccess(response.data));
    callback && callback(response);
  } catch (error) {
    yield put(deleteBidFail(""));
  }
}

function* onPostBidAction({ payload: { data, callback } }) {
  try {
    const response = yield call(postBidAction, data);
    callback && callback(response);
    if (response.status === "failure") {
      return yield put(postBidActionFail(response.message));
    }

    yield put(postBidActionSuccess(response.data));
  } catch (error) {
    yield put(postBidActionFail(""));
  }
}

function* onGetBids({ payload: { data, callback } }) {
  try {
    const response = yield call(getBids, data);

    if (response.status === "failure") {
      return yield put(getBidsFail(response.message));
    }

    yield put(getBidsSuccess(response));
    callback && callback();
  } catch (error) {
    yield put(getBidsFail(""));
  }
}

function* addFavourite({ payload: { data, callback } }) {
  try {
    const response = yield call(postFavourite, data);
    callback && callback(response);
    if (response.status === "failure") {
      return yield put(postFavouriteFail(response.message));
    }

    yield put(postFavouriteSuccess(response.data));
  } catch (error) {
    yield put(postFavouriteFail("Internal Error"));
  }
}
function* getFavouriteList({ payload: { data, callback } }) {
  try {
    const response = yield call(getFavourite, data);
    callback && callback(response);
    if (response.status === "failure") {
      return yield put(getFavouriteFail(response.message));
    }

    yield put(getFavouriteSuccess(response));
  } catch (error) {
    yield put(getFavouriteFail("Internal Error"));
  }
}

function* onGetSearch({ payload: { id, callback } }) {
  try {
    const response = yield call(getSearchData, id);

    if (response.status === "failure") {
      return yield put(getSearchFail(response.message));
    }

    yield put(getSearchSuccess(response.data));
    callback && callback(response.data);
  } catch (error) {
    yield put(getSearchFail("Internal Error"));
  }
}

function* onfetchUpcomingAuction({ payload: { data, callback } }) {
  try {
    const response = yield call(postUpcomingAuction, data);

    if (response.status === "failure") {
      return yield put(upcomingAuctionFail(response.message));
    }

    callback && callback();

    yield put(upcomingAuctionSuccess(response));
  } catch (error) {
    yield put(upcomingAuctionFail(error));
  }
}

function* onGetItemById({ payload: { id, callback } }) {
  try {
    const response = yield call(getItemByIdApi, id);
    if (response.status === "failure") {
      return yield put(getItemsByIdFail(response.message));
    }

    callback && callback();

    yield put(getItemsByIdSuccess(response));
  } catch (error) {
    yield put(getItemsByIdFail(error));
  }
}
function* onGetItemsOfCurrentOwner({ payload: { current_owner, callback } }) {
  try {
    const response = yield call(getCurrentOwerItemsApi, current_owner);
    if (response.status === "failure") {
      return yield put(getItemsOfCurrentOwnerByIdFail(response.message));
    }
    
    callback && callback();

    yield put(getItemsOfCurrentOwnerByIdSuccess(response));
  } catch (error) {
    yield put(getItemsOfCurrentOwnerByIdFail(error));
  }
}
function* likeViewCount({ payload: { data, callback } }) {
  try {
    const response = yield call(likeViewCountApi, data);
    if (response.status === "failure") {
      return yield put(likeViewCountFail(response.message));
    }
    callback && callback();

    yield put(likeViewCountdSuccess(response));
  } catch (error) {
    yield put(likeViewCountFail(error));
  }
}


function* userAllNftCount({ payload: { data, callback } }) {
  try {
    const response = yield call(userAllNftCountApi, data);
    callback && callback(response);
    if (response.status === "failure") {
      return yield put(userAllNftCountFail(response.message));
    }
    yield put(userAllNftCountSuccess(response));
  } catch (error) {
    yield put(userAllNftCountFail(error));
  }
}

function* nftFromCollection({ payload: { data, callback } }) {
  try {
    const response = yield call(nftFromCollectionApi, data);
    callback && callback(response);
    if (response.status === "failure") {
      return yield put(nftFromCollectionFail(response.message));
    }
    yield put(nftFromCollectionSuccess(response));
  } catch (error) {
    yield put(nftFromCollectionFail(error));
  }
}


function* ItemsSaga() {
  yield takeEvery(REPORT_ABUSE, onReportAbuse);
  yield takeEvery(GET_ITEMS, fetchItems);
  yield takeEvery(POST_ITEM, onPostItem);
  yield takeEvery(GET_ITEM_BY_TOKEN, onGetItemByToken);
  yield takeEvery(POST_ITEM_SALE, onPostItemSale);
  yield takeLatest(GET_ACTIVITIES, onGetActivities);
  yield takeEvery(POST_ITEM_BUY, onPostItemBuy);
  yield takeEvery(GET_ITEM, fetchItem);
  yield takeEvery(PUT_ITEM, onPutItem);
  yield takeEvery(POST_TOGGLE_ITEM_SALE, onPostToggleItemSale);
  yield takeEvery(POST_BID, onPostBid);
  yield takeEvery(DELETE_BID, onDeleteBid);
  yield takeEvery(POST_BID_ACTION, onPostBidAction);
  yield takeEvery(GET_BIDS, onGetBids);
  yield takeEvery(POST_FAVOURITE, addFavourite);
  yield takeEvery(GET_FAVOURITE, getFavouriteList);
  yield takeEvery(GET_SEARCH, onGetSearch);
  yield takeEvery(GET_ITEM_BY_ID, onGetItemById);
  yield takeLatest(UPCOMING_AUCTION, onfetchUpcomingAuction);
  yield takeLatest(GET_ITEM_BY_CURRENT_OWNER_ID, onGetItemsOfCurrentOwner);
  yield takeLatest(LIKE_VIEW_COUNT, likeViewCount);
  yield takeLatest(USER_ALL_NFT_COUNT, userAllNftCount);
  yield takeLatest(NFT_FROM_COLLECTION, nftFromCollection);
  // yield takeEvery(DELETE_ITEM, onDeleteItem)
}

export default ItemsSaga;
